export const getModelFolio = () => ({ iIdFolio: 0 });

export const getFormFiltroFolios = () => ({
    txtOrigen: {
        label: "Origen de folio:",
        value: "",
    },
    txtProducto: {
        label: "Producto Meditoc:",
        value: "",
    },
    txtVigente: {
        label: "Folio vigente:",
        value: "",
    },
});

export const getFolioColumns = () => [
    { title: "", field: "sStatus", hideFilter: true, hideSort: true },
    { title: "Folio", field: "sFolio" },
    { title: "Origen", field: "sOrigen" },
    { title: "Empresa", field: "sFolioEmpresa" },
    { title: "Paciente", field: "sNombrePaciente" },
    { title: "Correo", field: "sCorreoPaciente" },
    { title: "Creado", field: "sFechaCreacion" },
    { title: "Vencimiento", field: "sFechaVencimiento" },
];
